// extracted by mini-css-extract-plugin
export default {"main":"App_main__0J8jB","taskContainer":"App_taskContainer__zaruB"};